import React, { useEffect, useState } from 'react'
import { CNav, CNavItem, CNavLink, CCol, CFormLabel, CButton, CCardBody, CCard, CFormInput, CRow, CModal, CModalHeader, CModalTitle, CModalBody, CModalFooter } from '@coreui/react'
import GetDiagnosisData from '../../services/general/getDiagnosisData.api'
import SaveQuestionProvider from '../../services/general/saveQuestionsProvider.api'
import Pageloader from '../../components/shared/Pageloader'
import { CircleCheck, CircleX, CirclePlus, AlignLeft } from 'lucide-react'
import { HiPencil } from 'react-icons/hi'
import CustomFormBuilder from './CustomFormBuilder'
import DivLoader from '../../components/shared/DivLoader'
import AssesmentSuggestion from './AssesmentSuggestion'
import ListView from '../../components/shared/ListView'
import SaveExtra from '../../services/general/saveExtraData.api'
import toast from 'react-hot-toast'
import { toastConfig } from '../../constants/other.config'
import { motion } from 'framer-motion'
import AssesmentPlanSuggestion from './AssesmentPlanSuggestion'
import './MergeSuggestions.css'

const MergeSuggestions = () => {
  const [boxView, setBoxView] = useState('list')
  const [active, setActive] = useState('list')
  const [currentView, setCurrentView] = useState('list')
  const [diagnosisData, setDiagnosisData] = useState([])
  const [fetchedQuestions, setFetchedQuestions] = useState([])
  const [isPageLoading, setIsPageLoading] = useState(true)
  const [editComponentType, setEditComponentType] = useState(null)
  const [editDiagnosis, setEditDiagnosis] = useState(null)
  const [suggestionData, setSuggestionData] = useState(null)
  const [selectedDiagnosis, setSelectedDiagnosis] = useState(null)
  const [isModalVisible, setIsModalVisible] = useState(false)
  const [currentDiagnosis, setCurrentDiagnosis] = useState(null)
  const [editModelVisible, setEditModelVisible] = useState(false)
  const [activeTab, setActiveTab] = useState('basic')
  const [deleteModelVisible, setDeleteModelVisible] = useState(false)
  const [deleteDataId, setDeleteDataId] = useState([])

  const getSuggestionData = async () => {
    setIsPageLoading(true)
    try {
      let data = await SaveExtra('Get_By_Type', 'AssesmentSuggestions', '', '')
      data = JSON.parse(data.d)?.Data || []

      if (data) {
        data = data?.map((item) => {
          return {
            Id: item.Id,
            Data: JSON.parse(item?.JsonData),
          }
        })
      }

      setSuggestionData(data)
    } catch (error) {
      console.log(error)
    } finally {
      setIsPageLoading(false)
    }
  }

  const getDiagnosis = async () => {
    try {
      const response = await GetDiagnosisData()
      const data = JSON.parse(response.d)
      const options = data.Data.sort((a, b) => a.Name.trim().localeCompare(b.Name.trim())).map((obj) => ({
        value: obj.id,
        label: obj.Name.trim(),
      }))

      setDiagnosisData(options)
    } catch (error) {
      console.error('Error fetching diagnosis data:', error)
    }
  }

  // if (fetchedQuestions) {

  //     if (fetchedQuestions[0]?.questionType?.length === 0) {
  //         getQuestion()
  //     }
  // }

  const fetchData = async () => {
    await getSuggestionData()
    await getDiagnosis()
  }
  useEffect(() => {
    fetchData()
  }, [])

  const handleEditFunction = (item) => {
    setEditModelVisible(true)
    setSelectedDiagnosis(item)
    // setCurrentView('edit')
    // setBoxView('edit');
    // setActive('edit');
  }

  const handleDeleteSuggestion = async (item) => {
    if (item.length > 0) {
      let data = await SaveExtra('DELETE', 'AssesmentSuggestions', '', item[0].Id)
      if (data) {
        toast.success('Successfully Delete', toastConfig)
      }
    }
    setDeleteModelVisible(false)
    fetchData()
  }
  const handleView = (item) => {
    setSelectedDiagnosis(item)
    setIsModalVisible(true)
  }

  const closeModal = () => {
    setIsModalVisible(false)
    setCurrentDiagnosis(null) // Reset current diagnosis
  }
  const closeEditModel = () => {
    setEditModelVisible(false)
  }
  const renderView = () => {
    if (currentView === 'formBuilder') {
      return <CustomFormBuilder componentType={editComponentType} componentDiagnosis={editDiagnosis} />
    }

    if (currentView === 'add') {
      return <AssesmentSuggestion />
    }

    if (currentView === 'list') {
      return (
        <DivLoader isLoading={isPageLoading}>
          <div className="merge-suggestions-theme__content">
            {active === 'list' && (
              <div className="merge-suggestions-theme__list-shell">
                <CRow className="p-2 merge-suggestions-theme__list-grid">
                  {diagnosisData.map((item, index) => {
                    try {
                      let dataStatus = suggestionData.filter((suggestion) => suggestion.Data.diagnosis.value === item.value && suggestion.Data.accordions && suggestion.Data.accordions.length > 0)
                      return (
                        <CCol xs={12} md={6} xl={4} key={index}>
                          <ListView
                            heading={item.label}
                            editFunc={() => handleEditFunction(item)}
                            deleteFunc={() => {
                              ;(setDeleteModelVisible(true), setDeleteDataId(dataStatus))
                            }}
                            contentMatch={dataStatus.length > 0 ? true : false}
                            setSelectedDiagnosis={setSelectedDiagnosis}
                          ></ListView>
                        </CCol>
                      )
                    } catch (error) {
                      return (
                        <CCol xs={12} md={6} xl={4} key={index}>
                          <div className="text-danger">An error occurred while processing this diagnosis.</div>
                        </CCol>
                      )
                    }
                  })}
                </CRow>
              </div>
            )}
          </div>
        </DivLoader>
      )
    }

    if (currentView === 'edit') {
      return (
        <div>
          <AssesmentSuggestion parentDiagnosis={selectedDiagnosis} />
        </div>
      )
    }
  }

  return (
    <div className="position-relative patient-theme-page merge-suggestions-theme" data-theme={localStorage.getItem('provio_theme') || 'dark'}>
      <div className="patient-page-wrapper page-wrapper patient-theme-shell dashboard-dark-theme">
      {/* <CCard className="m-2 master-grid-theme__toolbar merge-suggestions-theme__toolbar">
        <CCardBody className="p-0 master-grid-theme__toolbar-body merge-suggestions-theme__toolbar-body">
          <div className="d-flex align-items-center justify-content-end merge-suggestions-theme__toolbar-actions">
            <CButton
              onClick={() => {
                setBoxView('list')
                setActive('list')
                setCurrentView('list')
                fetchData()
              }}
              color={boxView === 'list' ? 'primary' : 'secondary'}
              className={`d-flex align-items-center justify-content-center merge-suggestions-theme__view-toggle ${boxView === 'list' ? 'merge-suggestions-theme__view-toggle--active' : ''}`}
            >
              <AlignLeft size={16} strokeWidth={1.25} />
              <div className="merge-suggestions-theme__view-toggle-label">List</div>
            </CButton>

            {currentView === 'edit' ? (
              <CButton
                disabled
                color={boxView === 'edit' ? 'primary' : 'secondary'}
                className={`d-flex align-items-center justify-content-center merge-suggestions-theme__view-toggle ${boxView === 'edit' ? 'merge-suggestions-theme__view-toggle--active' : ''}`}
              >
                <CirclePlus size={16} strokeWidth={1.25} />
                <div className="merge-suggestions-theme__view-toggle-label">Edit</div>
              </CButton>
            ) : (
              <CButton
                disabled
                onClick={() => {
                  setBoxView('add')
                  setActive('add')
                  setCurrentView('add')
                }}
                color={boxView === 'add' ? 'primary' : 'secondary'}
                className={`d-flex align-items-center justify-content-center merge-suggestions-theme__view-toggle ${boxView === 'add' ? 'merge-suggestions-theme__view-toggle--active' : ''}`}
              >
                <CirclePlus size={16} strokeWidth={1.25} />
                <div className="merge-suggestions-theme__view-toggle-label">Add</div>
              </CButton>
            )}
          </div>
        </CCardBody>
      </CCard> */}

      <CModal className="patient-theme-modal merge-suggestions-theme__modal" backdrop="static" size="lg" visible={isModalVisible} onClose={closeModal}>
        <CModalHeader>
          <CModalTitle>View</CModalTitle>
        </CModalHeader>
        <CModalBody className="merge-suggestions-theme__modal-body">
          <AssesmentSuggestion showSelect={false} parentDiagnosis={selectedDiagnosis} />
        </CModalBody>
        <CModalFooter>
          <CButton color="secondary" onClick={closeModal}>
            Close
          </CButton>
        </CModalFooter>
      </CModal>

      <CModal
        backdrop="static"
        size="xl"
        visible={editModelVisible}
        // onClose={closeEditModel}
        className="custom-modal patient-theme-modal merge-suggestions-theme__modal"
      >
        <CModalBody className="merge-suggestions-theme__modal-body">
          <AssesmentPlanSuggestion showSelect={true} parentDiagnosis={selectedDiagnosis} closeEditModel={closeEditModel} fetchData={fetchData} />
        </CModalBody>
        {/* <CModalFooter>
                <CButton color="secondary" onClick={closeEditModel}>
                    Close
                </CButton>
            </CModalFooter> */}
      </CModal>

      <CModal className="patient-theme-modal merge-suggestions-theme__modal" backdrop="static" visible={deleteModelVisible} onClose={() => setDeleteModelVisible(false)}>
        <CModalHeader>
          <CModalTitle>Warning</CModalTitle>
        </CModalHeader>
        <CModalBody className="merge-suggestions-theme__modal-body">
          <p className="fs-6 p-0 m-0">Are you sure you want to delete?</p>
        </CModalBody>
        <hr className="p-0 m-0" />
        <CModalFooter className="p-3 m-0">
          <CButton
            onClick={() => {
              setDeleteModelVisible(false)
            }}
            variant="outline"
            color="secondary"
          >
            Close
          </CButton>
          <CButton variant="outline" onClick={() => handleDeleteSuggestion(deleteDataId)} className="" color="danger">
            Delete
          </CButton>
        </CModalFooter>
      </CModal>

      {renderView()}
      </div>
    </div>
  )
}

export default MergeSuggestions
